/* Payment details "Change history" Download CSV: pure column map + an every-page loader per source. */
import { collect_all_pages } from '../../../util_components/csv_export/collect_pages';
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { change_lines, list_params } from './change_history_logic';

const RECORD_LABELS = { teacher_attr: 'Payment settings', base_rate: 'Base rate' };

// Rows are raw GET /audit/list rows; the change text is the same wording the table shows.
export const CHANGE_HISTORY_CSV_COLUMNS = [
  { header: 'Change ID', key: 'id' },
  { header: 'When (IST)', key: 'created_at_ist', kind: 'datetime' },
  { header: 'Changed by', value: (r) => (r.actor && (r.actor.name || r.actor.id)) || '' },
  { header: 'Record', value: (r) => RECORD_LABELS[r.entity_type] || r.entity_type || '' },
  { header: 'Change', value: (r) => change_lines(r) },
  { header: 'Reason', value: (r) => (r.reason || '').trim() }
];

export const change_history_csv_name = (teacher_uuid) =>
  csv_file_name({
    page: `teacher-${String(teacher_uuid || '').slice(-8)}`,
    table: 'payment-change-history'
  });

/*
 * Every page of every source (the screen may hold only the first 50), merged newest first by id
 * like the table. capped when any source hit the row cap.
 */
export const change_history_csv_loader = (fetch_list, teacher_uuid, sources) => () =>
  Promise.all(
    sources.map((s) =>
      collect_all_pages((before_id) =>
        fetch_list(list_params(teacher_uuid, s, before_id)).then((page) => {
          const next = Number(page && page.next_before_id);
          return {
            rows: page && Array.isArray(page.rows) ? page.rows : [],
            next: Number.isFinite(next) && next > 0 ? next : null
          };
        })
      )
    )
  ).then((results) => {
    const seen = new Set();
    const rows = results
      .flatMap((r) => r.rows)
      .filter((r) => (seen.has(r.id) ? false : seen.add(r.id)))
      .sort((a, b) => b.id - a.id);
    const capped = results.find((r) => r.capped);
    return { rows, capped: !!capped, cap: capped ? capped.cap : undefined };
  });
